<script setup lang="ts">
import { ref } from "vue";
import ShoppingCart from "@/components/apps/ecommerce/cart/steps/ShoppingCart.vue";
import OrderSummary from "@/components/apps/ecommerce/cart/steps/OrderSummary.vue";
import { useInvoiceStore } from "~/stores/apps/invoice";
import { useThirdpartyStore } from "@/stores/apps/thirdparty";
import { IconCloudCheck, IconCloudUpload } from "@tabler/icons-vue";
import SharedPreloader from "@/components/shared/Preloader.vue";

import { checkoutMixin } from "@/pages/apps/ecommerce/checkoutMixin";
const { createUpdateInvoice } = checkoutMixin();

const invoiceLoading = ref(false);
const invoiceStore = useInvoiceStore();

const saveOrder = async () => {
    invoiceLoading.value = false;
    try {
        await createUpdateInvoice();
    } catch (e) {
        invoiceLoading.value = false;
        console.error(e);
    }
};
</script>

<!------------------------------------->
<!-- Order Summary (Right Panel) -->
<!------------------------------------->
<template>
    <SharedPreloader v-if="invoiceLoading" />
    <div class="pa-6">
        <h5 class="text-h5">{{ $t("Order Summary") }}</h5>
    </div>
    <v-divider></v-divider>
    <perfect-scrollbar style="height: calc(100vh - 90px)">
        <div class="pa-3">
            <ShoppingCart :isOrderSummary="true" />
            <OrderSummary :onlyTotal="true" />
            <v-btn
                v-if="`${invoiceStore.invoiceId}` === ''"
                :loading="invoiceLoading"
                block
                color="primary"
                :disabled="!useThirdpartyStore().thirdparty?.id"
                class="mt-3"
                rounded="md"
                size="large"
                @click="saveOrder()"
            >
                <IconCloudUpload size="20" class="mr-2" />
                {{ $t("basic.save") }}
            </v-btn>
            <v-btn
                v-else
                :loading="invoiceLoading"
                block
                color="success"
                :disabled="!useThirdpartyStore().thirdparty?.id"
                class="mt-3"
                rounded="md"
                size="large"
                @click="saveOrder()"
            >
                <IconCloudCheck size="20" class="mr-2" />
                {{ $t("basic.update") }}
            </v-btn>
        </div>
    </perfect-scrollbar>
</template>

<style lang="scss"></style>
